// Home page SEO — keep in sync with public/index.html (title, meta, og, JSON-LD).

export const PAGE_TITLE_HOME = "Max Fitness Năvodari | Sală de fitness în Năvodari";

export const META_DESCRIPTION_HOME =
  "Sală de fitness în Năvodari, lângă Constanța. Echipamente moderne, zonă cardio, sală de forță, antrenori și abonamente flexibile. Vezi prețurile și contactează Max Fitness.";
